import React, { Component } from 'react';
import { Field } from 'formik';
import { Button, message } from 'antd';
import * as yup from 'yup';
import { asyncConnect } from 'react-async-client';
import { path } from 'ramda';

import PageForm from 'components/common/PageForm';
import SwitchInput from 'components/common/form/SwitchInput';
import HeadBlock from 'components/common/cards/HeadBlock';
import Spinner from 'components/common/Spinner';
import {
    formAutoOptions,
    fullAutoOptions,
    getSalesGeneralSettings,
    putSalesGeneralSettings,
} from 'actions/asyncActions';

@asyncConnect({
    getSalesGeneralSettings: getSalesGeneralSettings.withOptions(fullAutoOptions),
    putSalesGeneralSettings: putSalesGeneralSettings
        .withSuccessHandler(({ getSalesGeneralSettings }, action) => {
            message.success('Настройки успешно сохранены.');
            if (action.payload) {
                getSalesGeneralSettings.success(action.payload);
            }
        })
        .withOptions(formAutoOptions),
})
export default class SalesGeneralSettings extends Component {
    getValidationSchema() {
        return yup.object().shape({
            requireWorkShift: yup.boolean(),
        });
    }

    renderForm = ({ isSubmitting, handleSubmit }) => (
        <div>
            <div className='sales-general-switch'>
                <Field
                    name='requireWorkShift'
                    component={SwitchInput}
                />
                <label htmlFor='requireWorkShift'>Продажу можно внести только в рабочую смену</label>
            </div>
            <Button
                type='primary'
                htmlType='submit'
                disabled={isSubmitting}
                onClick={handleSubmit}
            >
                Сохранить
            </Button>
        </div>
    );

    render() {
        const { putSalesGeneralSettings } = this.props;
        const data = path(['getSalesGeneralSettings', 'data'], this.props) || {};
        const meta = path(['getSalesGeneralSettings', 'meta'], this.props) || {};

        if (!data.id && !meta.success && !meta.error) {
            return <Spinner />;
        }

        return (
            <div className='sales-form'>
                <HeadBlock title='Общие настройки продаж' hideBack />
                <PageForm
                    initialValues={{
                        requireWorkShift: data.requireWorkShift !== false,
                    }}
                    validationSchema={this.getValidationSchema()}
                    formAction={putSalesGeneralSettings}
                    mapBeforeSubmit={values => ({
                        requireWorkShift: !!values.requireWorkShift,
                    })}
                    renderForm={this.renderForm}
                />
            </div>
        );
    }
}
